import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { baseURL } from 'Types/APITypes';
import { useQuery } from 'react-query';

function getCopyServicesLocationList(btNumber: string, type:'tires'|'mechanical'|'services') {
  const apiType: MaestroAPI = { method: 'GET', endpoint: `locations/${btNumber}/locations-copy-services`, baseURL };
  return maestroApiCall(apiType, { type });
}

export default function useCopyServicesLocationList(btNumber: string, type:'tires'|'mechanical'|'services') {
  return useQuery(['copy-services', btNumber, type], () => getCopyServicesLocationList(btNumber, type));
}
